import { drillFragmentData, graphql } from '@e-socna/data-layer';

import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';

import { TimeManagement } from '../../components/Illustrations/TimeManagement';
import { useMissionReadyContext } from '../../contexts/MissionContext/hooks/useMissionReadyContext.hook';
import { formatDate } from '../../utils/format-date.util';

import { MissionPage_Tabs_Mission_Fragment } from './Tabs';

export const MissionPage_ArchiveInfo_Mission_Fragment = graphql(`
  fragment MissionPage_ArchiveInfo_Mission_Fragment on Mission {
    archiveInfo {
      startDateForAnalytics
      endDateForAnalytics
      iHavedCheckedThatReportHasBeenUploaded
      iHavedCheckedThatPlansHaveBeenUploaded
      iHavedCheckedThatQuotationHasBeenUploaded
      iHavedCheckedThatHypothesisNotesHaveBeenUploaded
      archiveBinders
    }
  }
`);

export const ArchiveInfo = () => {
  const { mission: rawMission } = useMissionReadyContext();
  const mission = drillFragmentData(
    [
      MissionPage_Tabs_Mission_Fragment,
      MissionPage_ArchiveInfo_Mission_Fragment,
    ],
    rawMission,
  );

  if (!mission.archiveInfo) {
    return (
      <TimeManagement title="Les données d'archivage ne sont pas encore disponibles" />
    );
  }

  return (
    <Stack spacing={2} sx={{ pt: 4, width: '100%' }}>
      <Typography gutterBottom variant="h6">
        Classeurs
      </Typography>
      <Paper sx={{ p: 2 }}>
        <Box sx={{ position: 'relative' }}>
          <Typography gutterBottom variant="body1">
            {mission.archiveInfo.archiveBinders.join(', ')}
          </Typography>
        </Box>
      </Paper>
      <Typography gutterBottom variant="h6">
        Période
      </Typography>
      <Paper sx={{ p: 2 }}>
        <Box sx={{ position: 'relative' }}>
          <Typography gutterBottom variant="body1">
            Date d&apos;ouverture :{' '}
            {formatDate(mission.archiveInfo.startDateForAnalytics)}
          </Typography>
          <Typography gutterBottom variant="body1">
            Date de fermeture :{' '}
            {formatDate(mission.archiveInfo.endDateForAnalytics)}
          </Typography>
        </Box>
      </Paper>
      <Typography gutterBottom variant="h6">
        J&apos;ai vérifié que ...
      </Typography>
      <Paper sx={{ p: 2 }}>
        <Box sx={{ position: 'relative' }}>
          <Typography gutterBottom variant="body1">
            Le rapport était bien présent ? :{' '}
            {mission.archiveInfo.iHavedCheckedThatReportHasBeenUploaded
              ? 'Oui'
              : 'Non'}
          </Typography>
          <Typography gutterBottom variant="body1">
            Les plans étaient bien présents ? :{' '}
            {mission.archiveInfo.iHavedCheckedThatPlansHaveBeenUploaded
              ? 'Oui'
              : 'Non'}
          </Typography>
          <Typography gutterBottom variant="body1">
            Le devis était bien présent ? :{' '}
            {mission.archiveInfo.iHavedCheckedThatQuotationHasBeenUploaded
              ? 'Oui'
              : 'Non'}
          </Typography>
          <Typography gutterBottom variant="body1">
            Les notes de calcul étaient bien présentes ? :{' '}
            {mission.archiveInfo
              .iHavedCheckedThatHypothesisNotesHaveBeenUploaded
              ? 'Oui'
              : 'Non'}
          </Typography>
        </Box>
      </Paper>
    </Stack>
  );
};
